'use client'

import { createClient } from '@/lib/supabase/client'
import { useRouter } from 'next/navigation'
import { Hint } from '@/components/hint'
import { clearUserStorage } from '@/lib/user-storage'

export function LogoutButton() {
  const router = useRouter()

  const logout = async () => {
    const supabase = createClient()
    await supabase.auth.signOut()
    clearUserStorage()
    router.push('/auth/login')
    router.refresh()
  }

  return (
    <Hint title="Выйти" text="Выход из аккаунта на этом устройстве. Прогресс сохранён, при следующем входе всё будет на месте.">
    {/* На узком экране — круглая кнопка со значком «дверь» (32 px, как
        «Настройки»): текстовая не помещалась в шапку на 390 px. */}
    <button
      onClick={logout}
      aria-label="Выйти"
      className="tk-dash-tab tk-dash-tab--ice flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border text-sm font-medium text-fg-muted sm:h-auto sm:w-auto sm:px-4 sm:py-2"
    >
      <svg className="sm:hidden" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15" aria-hidden="true">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <path d="M16 17l5-5-5-5"></path>
        <path d="M21 12H9"></path>
      </svg>
      <span className="hidden sm:inline">Выйти</span>
    </button>
    </Hint>
  )
}
